import { createSlice } from "@reduxjs/toolkit";



export const userSlice = createSlice({
    name: 'user',
    initialState: {
        user: null
    },
    reducers: {
        injectUser: (state, action) => {
            state.user = action.payload
        }
    }
})


export const { injectUser } = userSlice.actions
export default userSlice.reducer